export default __webpack_public_path__ + "static/media/iconClose.2ea0f883.svg";